const bodyElement = document.querySelector('body');

class Modal {
    constructor (modalId, onModalOpen) {
        this.modalEl = document.querySelector(modalId);
        this.modalCloseEl = this.modalEl.querySelector('.js-modal-close');
        this.previousScrollY = 0;

        this.setPreviousScrollY();
        this.backdropEl = this.modalEl.parentNode;
        this.backdropEl.classList.add('is-visible');
        bodyElement.classList.add('modal-open');
        if (onModalOpen) {
            onModalOpen();
        }

        if (this.openModal) {
            this.openModal.removeListeners();
        }

        this.addListeners();
        this.openModal = this;
    }

    close () {
        this.openModal = null;
        this.backdropEl.classList.remove('is-visible');
        bodyElement.classList.remove('modal-open');
        window.scrollTo(0, this.previousScrollY);
    }

    setPreviousScrollY () {
        this.previousScrollY = window.pageYOffset || document.documentElement.scrollTop;
    }

    addListeners () {
        if (this.modalCloseEl) {
            this.modalCloseEl.addEventListener('click', this.handleCloseClick.bind(this), true);
        }
    }

    handleCloseClick (event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.openModal) {
            this.openModal.close();
        }
    }
}

const openContactUsModalContrs = document.querySelectorAll('[href="/contact/"]');

for (const modalContr of openContactUsModalContrs) {
    // set underlay location to animate from cursor position
    // modalContr.addEventListener('mousedown', function(eve) {
    //     console.log('X', eve.clientX);
    //     console.log('Y', eve.clientY);
    //     document.getElementsByClassName('modal-underlay')[0].setAttribute('style', 'top: ' + eve.clientY + 'px; left:' + eve.clientX + 'px;');
    // });
    modalContr.addEventListener('click', function(eve) {
        eve.preventDefault();
        const targetModalId = '#contactusModal';
        const targetModalObj = new Modal(targetModalId);
    });
}
